import Vue from 'vue'
import Router from 'vue-router'
import firebase from '@/firebase'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/transport_details_sheet',
      name: 'transport_details_sheet',
      component: () => import(/* webpackChunkName: "transport_details_sheet" */ '@/views/transport_details_sheet.vue'),
      meta: { title: "交通費詳細データ印刷", isAdminOnly: false }
    },
    {
      path: '/images_sheet',
      name: 'images_sheet',
      component: () => import(/* webpackChunkName: "images_sheet" */ '@/views/images_sheet.vue'),
      meta: { title: "交通費詳細画像印刷", isAdminOnly: false }
    },
    // ログイン前ルート
    {
      path: '/',
      component: () => import(/* webpackChunkName: "beforeLoginLayout" */ '@/views/beforeLoginLayout.vue'),
      children: [
        {
          path: '/',
          name: 'index',
          component: () => import(/* webpackChunkName: "index" */ '@/views/index.vue'),
          meta: { title: "", hasSelfHeader: true }
        },
        {
          path: '/sign_up',
          name: 'sign_up',
          component: () => import(/* webpackChunkName: "sign_up" */ '@/views/sign_up.vue'),
          meta: { title: "会社登録" }
        },
        {
          path: '/sent_email',
          name: 'sent_email',
          component: () => import(/* webpackChunkName: "sent_email" */ '@/views/sent_email.vue'),
          meta: { title: "" }
        },
        {
          path: '/compleate_registration',
          name: 'compleate_registration',
          component: () => import(/* webpackChunkName: "compleate_registration" */ '@/views/compleate_registration.vue'),
          meta: { title: "会社登録" }
        },
        {
          path: '/login',
          name: 'login',
          component: () => import(/* webpackChunkName: "login" */ '@/views/login.vue'),
          meta: { title: "ログイン" }
        },
        {
          path: '/sign_in',
          name: 'sign_in',
          component: () => import(/* webpackChunkName: "sign_in" */ '@/views/sign_in.vue'),
          meta: { title: "ログイン" }
        },
        {
          path: '/finish_withdrawal',
          name: 'finish_withdrawal',
          component: () => import(/* webpackChunkName: "finish_withdrawal" */ '@/views/finish_withdrawal.vue'),
          meta: { title: "退会" }
        },
        {
          path: '/auth_failed',
          name: 'auth_failed',
          component: () => import(/* webpackChunkName: "auth_failed" */ '@/views/auth_failed.vue'),
          meta: { title: "メール認証失敗" }
        }
      ]
    },

    // ログイン後ルート
    {
      path: '/app',
      component: () => import(/* webpackChunkName: "afterLoginLayout" */ '@/views/afterLoginLayout.vue'),
      children: [
        {
          path: '/company',
          name: 'company',
          component: () => import(/* webpackChunkName: "company" */ '@/views/company.vue'),
          meta: { title: "会社情報", isAdminOnly: true }
        },
        {
          path: '/transports',
          name: 'transports',
          component: () => import(/* webpackChunkName: "transports" */ '@/views/transports.vue'),
          meta: { title: "交通費管理", isAdminOnly: false }
        },
        {
          path: '/transports/detail',
          name: 'transport_detail',
          component: () => import(/* webpackChunkName: "transport_detail" */ '@/views/transport_detail.vue'),
          meta: { title: "さんの交通費", isAdminOnly: false }
        },
        {
          path: '/user',
          name: 'user',
          component: () => import(/* webpackChunkName: "user" */ '@/views/user.vue'),
          meta: { title: "ユーザー情報", isAdminOnly: true }
        },
        {
          path: '/withdrawal',
          name: 'withdrawal',
          component: () => import(/* webpackChunkName: "withdrawal" */ '@/views/withdrawal.vue'),
          meta: { title: "退会", isAdminOnly: true }
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name == "index") {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        next({ name: "transports" })
      }
    })
  }

  next()
})

export default router